'use client';

import { c as _c } from "react/compiler-runtime";
import { Show, useUser } from '@clerk/nextjs';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { getUserInitials } from '@/components/navbar/utils';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Skeleton } from '@/components/ui/skeleton';
import { buildPrimaryAuthUrl, isSatelliteHost, SignInModal, SignUpModal } from '@/features/auth';
import { matchBrandFromHostname } from '@/features/brand/utils';
interface ActionButtonsProps {
  email?: string;
  showWatchButton?: boolean;
  showAuthButtons?: boolean;
}
export function ActionButtonsSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-2 justify-self-end md:gap-3"><Skeleton className="h-7 w-16 sm:w-20 md:h-9 md:w-28" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function ActionButtons(t0) {
  const $ = _c(26);
  const {
    email,
    showWatchButton: t1,
    showAuthButtons: t2
  } = t0;
  const showWatchButton = t1 === undefined ? true : t1;
  const showAuthButtons = t2 === undefined ? false : t2;
  const {
    user
  } = useUser();
  const pathname = usePathname();
  const router = useRouter();
  const [isSatellite, setIsSatellite] = useState(false);
  const [showSignIn, setShowSignIn] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsSatellite(isSatelliteHost(window.location.host, process.env.NODE_ENV === "development" ? "development" : "production"));
    };
    t4 = [];
    $[0] = t3;
    $[1] = t4;
  } else {
    t3 = $[0];
    t4 = $[1];
  }
  useEffect(t3, t4);
  const handleSignInRedirect = _temp;
  const handleSignUpRedirect = _temp2;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setShowSignUp(true);
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const openSignUpModal = t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setShowSignIn(true);
    };
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const openSignInModal = t6;
  let t7;
  if ($[4] !== pathname || $[5] !== router) {
    t7 = () => {
      if (pathname !== "/account") {
        router.push("/account");
      }
    };
    $[4] = pathname;
    $[5] = router;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const handleAccountButton = t7;
  const userEmail = email || user?.primaryEmailAddress?.emailAddress || user?.emailAddresses[0]?.emailAddress || "";
  let t8;
  if ($[7] !== isSatellite || $[8] !== showAuthButtons || $[9] !== showSignIn || $[10] !== showSignUp) {
    t8 = showAuthButtons && <Show when="signed-out">{isSatellite ? <><button type="button" onClick={handleSignInRedirect} className="px-2 py-1.5 font-medium text-[0.65rem] text-white uppercase tracking-wider transition-colors hover:text-white/80 sm:px-3 sm:text-xs md:px-4 md:py-2 md:text-sm">Sign In</button><button type="button" onClick={handleSignUpRedirect} className="bg-white px-2 py-1.5 font-medium text-[0.65rem] text-black uppercase tracking-wider transition-colors hover:bg-white/90 sm:px-3 sm:text-xs md:px-4 md:py-2 md:text-sm">Sign Up</button></> : <><button type="button" onClick={openSignInModal} className="px-2 py-1.5 font-medium text-[0.65rem] text-white uppercase tracking-wider transition-colors hover:text-white/80 sm:px-3 sm:text-xs md:px-4 md:py-2 md:text-sm">Sign In</button><button type="button" onClick={openSignUpModal} className="bg-white px-2 py-1.5 font-medium text-[0.65rem] text-black uppercase tracking-wider transition-colors hover:bg-white/90 sm:px-3 sm:text-xs md:px-4 md:py-2 md:text-sm">Sign Up</button><SignInModal isOpen={showSignIn} onClose={() => setShowSignIn(false)} /><SignUpModal isOpen={showSignUp} onClose={() => setShowSignUp(false)} /></>}</Show>;
    $[7] = isSatellite;
    $[8] = showAuthButtons;
    $[9] = showSignIn;
    $[10] = showSignUp;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = `Account (${userEmail || "account"})`;
  let t10;
  if ($[12] !== userEmail) {
    t10 = getUserInitials(userEmail);
    $[12] = userEmail;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10) {
    t11 = <Avatar className="size-7 shadow-lg ring-2 ring-black/20 transition-all hover:ring-2 hover:ring-white/30 md:size-8"><AvatarFallback className="bg-gray-500/30 font-semibold text-sm text-white ring-1 ring-white/10 ring-inset backdrop-blur-sm">{t10}</AvatarFallback></Avatar>;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== handleAccountButton || $[17] !== t11 || $[18] !== t9) {
    t12 = <Show when="signed-in"><button type="button" onClick={handleAccountButton} title={t9}>{t11}</button></Show>;
    $[16] = handleAccountButton;
    $[17] = t11;
    $[18] = t9;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== showWatchButton) {
    t13 = showWatchButton && <a className="bg-white px-2 py-1.5 font-medium text-[0.65rem] text-black uppercase tracking-wider transition-colors hover:bg-white/90 sm:px-3 sm:text-xs md:px-6 md:py-2 md:text-sm" href="/browse">Watch Now</a>;
    $[20] = showWatchButton;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t12 || $[23] !== t13 || $[24] !== t8) {
    t14 = <div className="flex items-center gap-2 justify-self-end md:gap-3">{t8}{t12}{t13}</div>;
    $[22] = t12;
    $[23] = t13;
    $[24] = t8;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
}
function _temp2() {
  const signupBrandId = matchBrandFromHostname(window.location.host);
  const url_0 = buildPrimaryAuthUrl({
    action: "sign-up",
    redirectUrl: `${window.location.origin}/browse`,
    signupBrandId
  });
  window.location.assign(url_0);
}
function _temp() {
  const url = buildPrimaryAuthUrl({
    action: "sign-in",
    redirectUrl: `${window.location.origin}/browse`
  });
  window.location.assign(url);
}